<template>
  <div class="page-content">
    <div class="page-body">
      <div class="dashboard-navigation">
        <div class="email-content">
          <div class="code m-3">
            <InputText
              id="title"
              label="Code"
              placeholder="code"
              v-model="code"
            />
          </div>

          <div class="code m-3">
            <InputText
              id="title"
              label="Tags"
              placeholder="code"
              v-model="tags"
            />
          </div>


          <div class="recipient m-3">
            <InputText
              id="title"
              label="Recipient"
              placeholder="Recipient"
              v-model="recipient"
            />
          </div>
          <div class="subject m-3">
            <InputText
              id="title"
              label="Subject"
              placeholder="Subject"
              v-model="subject"
            />
          </div>
          <div class="message m-3">
            <InputText
              ref="messageTextField"
              label="Message"
              :placeholder="message"
              v-model="message"
              :maxLength="10000"
              textareaCustomClass="descriptionTextarea"
            />
          </div>

          <div class="button text-right m-3">
            <Btn @click.native="onSend()" label="Send Message" fix-width />
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
// @ is an alias to /src
import { HTTP } from '@/shared/http';
import InputText from '@/components/UI/InputText.vue';

export default {
  name: 'MyDashboard',
  components: {
    InputText,
  },

  data() {
    return {
      code: '',
      subject: '',
      recipient: '',
      message: '',
      tags:''
    };
  },

  methods: {
    onSend() {
      const data = {};

      data.code = this.code;
      data.subject = this.subject;
      data.recipient = this.recipient;
      data.message = this.message;
      data.tags = this.tags;
      console.log('onSend:', data);


      HTTP.post('/api/email', data)
        .then((response) => {
          console.log('Processing send message:', response.data);
          this.$refs.messageTextField.clearInput();
        })
        .catch((error) => console.log(error));
    },
  },

  computed: {
    navItems() {
      let items = [
        { code: 'my-polls', label: this.$t('polls.myPolls') },
        { code: 'my-contacts', label: this.$t('contacts.myContacts') },
        // { code: 'my-old-contacts', label: 'Old Contacts' },
      ];
      return items;
    },
  },
  mounted() {
    this.$store.commit('setVisibleNav', true);
  },
};
</script>

<style lang="scss">
@import '@/styles/style.scss';

.email-content {
  max-width: 600px;
  margin: 0 auto;
}

.page-content {
  -webkit-background-size: cover;
  -moz-background-size: cover;
  -o-background-size: cover;
  background-size: cover;
  background-color: $very-light-grey;
  min-height: 100vh;
  height: 100vh;
  overflow: hidden;
  display: flex;
  flex-direction: column;
}

.page-body {
  overflow: auto;
}

.dashboard-navigation {
  background-color: white;
  padding-top: 68px;
  flex-shrink: 0;
  flex-grow: 0;
}

.dashboard-content {
  display: flex;
  flex-direction: column;
}

.dashboard-margin {
  margin-left: 0px !important;
  margin-right: 0px !important;
  padding-left: $mobile-margin-left;
  padding-right: $mobile-margin-left;
}

@media screen and (min-width: 960px) {
  .dashboard-margin {
    margin-left: $desktop-margin-left !important;
    padding: 0px;
  }
}
</style>
